var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagJordan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8516C24.8366 32.8516 32 25.6881 32 16.8516C32 8.01501 24.8366 0.851562 16 0.851562C7.16344 0.851562 0 8.01501 0 16.8516C0 25.6881 7.16344 32.8516 16 32.8516Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 11.2864H31.0045C28.7438 5.19356 22.8791 0.851562 15.9997 0.851562C11.5813 0.851562 7.58177 2.64275 4.68652 5.53837L9.73884 11.2864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 22.417H31.0045C28.7438 28.5098 22.8791 32.8518 15.9997 32.8518C11.5813 32.8518 7.58177 31.0606 4.68652 28.165L9.73884 22.417Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 5.5376C-1.56212 11.786 -1.56212 21.9167 4.68625 28.1651C7.26831 25.583 9.75163 23.0997 16 16.8513L4.68625 5.5376Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34991 13.373L7.22798 15.2092L9.21104 14.7509L8.32291 16.5822L9.9176 17.8469L7.93216 18.2943L7.93766 20.3295L6.34991 19.0562L4.7621 20.3295L4.76766 18.2943L2.78223 17.8469L4.37685 16.5822L3.48885 14.7509L5.47179 15.2092L6.34991 13.373Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.851562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagJordan);
export default __webpack_public_path__ + "static/media/flag_jordan.3fedca2f5089db6ca0f89dfe4d5693a6.svg";
export { ForwardRef as ReactComponent };